import useAjax from "@hooks/use-ajax.hook";
import useDataStore from "@state/DataStore";
import { useCallback } from "react";
import { BoatType } from "src/types/types";

const useBoats = () => {
  const boats = useDataStore((state) => state.boats);
  const { request, error, loading, clearError } = useAjax();

  const fetchBoats = useCallback(async () => {
    const data = await request<BoatType[]>("get_boats");
    useDataStore.getState().setBoats(data ?? []);
  }, [request]);

  return { boats, loading, error, clearError, fetchBoats };
};

export default useBoats;
